import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Image = styled("img")({
  maxWidth: "80%",
  height: "auto",
  marginBottom: "20px",
});

const CompanyCulture = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        margin: "auto",
        padding: 4,
        textAlign: "flex-start",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        {t("companyCulture.title")}
      </Typography>
      <Image
        src="images/company-culture.jpg"
        alt={t("companyCulture.imageAlt")}
      />
      <Typography variant="body1" color="text.secondary" gutterBottom>
        {t("companyCulture.description")}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3, alignSelf: "flex-end", width: "200px" }}
        onClick={() => navigate("/survey")}
      >
        {t("companyCulture.start")}
      </Button>
    </Box>
  );
};

export default CompanyCulture;
